import Tags from './tags.js';
export default Tags;
